// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t2qU","rootNoMargin":"styles_rootNoMargin__3IXO4"};